import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';
import partnerPropTypes from '../../../partnerPropTypes';

const AgreementSentSummary = ({ partner }) => (
    <StatusSummaryButton href="/behandle-avtaleforslag" withOnboarding>
        {partner.name} vil bruke Trygg betaling
    </StatusSummaryButton>
);

AgreementSentSummary.propTypes = {
    partner: partnerPropTypes.isRequired,
};

export default AgreementSentSummary;



// WEBPACK FOOTER //
// ./safeTrade/seller/agreement/summaries/agreementSentSummary.jsx